import fp from 'lodash/fp';
import React, { useState, useMemo, useContext } from 'react';
import { Common } from '@factorin/domain';


type TransferLayoutContextType = {
    currentTab?: string;
    changeTab?: (tab: string) => void;
}

const TransferLayoutContext = React.createContext<TransferLayoutContextType>({});

export const useTransferLayoutContext = () => useContext(TransferLayoutContext);


type TransferLayoutType = {
    components: Common.Catalog<React.ComponentType>;
}

export const TransferLayout: React.ComponentType<TransferLayoutType> = React.memo(({
    components,
}) => {
    const keys = fp.keys(components);
    const [tab, changeTab] = useState(keys[0]);

    const value = useMemo(
        () => ({ currentTab: tab, changeTab }),
        [tab],
    );

    const Component = components[tab];

    return (
        <TransferLayoutContext.Provider value={value}>
            <Component />
        </TransferLayoutContext.Provider>
    );
});

export enum RegistersLayoutKeys {
    RegistersList = 'RegistersList',
    RegistersView = 'RegistersView',
}
